<ng-container *ngIf="formControl">
  <app-img-icon [url]="url"
                [iconMode]="iconMode"
                [icon]="icon"
                [size]="size">
  </app-img-icon>
</ng-container>
